/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_LandlordInputs */

const cs_property_legal_landlord = /** @type {(inputs: Property_Legal_LandlordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronajímatel`)
};

const en_property_legal_landlord = /** @type {(inputs: Property_Legal_LandlordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landlord`)
};

/**
* | output |
* | --- |
* | "Landlord" |
*
* @param {Property_Legal_LandlordInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_landlord = /** @type {((inputs?: Property_Legal_LandlordInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_LandlordInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_landlord(inputs)
	return cs_property_legal_landlord(inputs)
});